import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {  Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PluginService, AlertService } from '../../../services';
import { PageService, PageSectionService, LookupService } from '../../../services/models';
import { BaseEditComponent } from '../../base/base.edit.component';
import { Section } from '../../../models/section';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PublishDialogComponent } from '../../product.management/publishdialog/publish-dialog.component';

@Component({
    templateUrl: './pages.edit.component.html',
    styleUrls: ['./pages.edit.component.less'], 
    selector: 'pages-edit'
})

export class  PagesEditComponent extends BaseEditComponent implements OnInit {

    pagesForm: FormGroup;
    record: any = null;
    type: string = '';
    categories: any = [];
    zones: any = [];
    products_lookup_endpoint: string = "products";
    section_types: any = [];
    banner_types: any = [];
    draftPages: any = {};

    @Input() id: any = null;
    @Input() entity: string = null;
    @Output() close = new EventEmitter();

    constructor(
        private router: Router,
        private pageService: PageService,
        private sectionService: PageSectionService,
        private formBuilder: FormBuilder,
        protected pluginService: PluginService,
        protected alertService: AlertService,
        protected lookupService: LookupService,
        public dialog: MatDialog,
    ) {
        super(pluginService);
    }

    ngOnInit() {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        console.log(this.type);
        this.type = this.pageService.getType();
        this.pagesForm = this.formBuilder.group({
            name: ['', Validators.required],
            slug: ['', Validators.required],
            enabled: [''],
            meta_title: [''],
            meta_description: [''],
            meta_image: [''],
            list_image_url: [''],
            blurb: [''],
            category: ['', Validators.required],
            related_entity_id: [''],
            zone: [''],
            display_timestamp : [''],
            is_campaign : [''],
            campaign_banner_url : [''],
            campaign_start : [''],
            campaign_end : [''],
            facebook_share_image : [''],            
            page_start_date: [''],
            page_end_date: [''],

        });

		this.lookupService.getAll("section_types")
			.subscribe(
				data => {
						// if(this.type == 'microsites')
                        this.section_types = data.data;
            //  else
            //   this.section_types = data.data.filter(item => (item.id < 15 || item.id == 23 || item.id == 24));
				},
				error => {
                });

        setTimeout(()=>{
        this.lookupService.getAll("banner_types")
            .subscribe(
                data => {
                        this.banner_types = data.data;
                },
                error => {
                });
        });

        this.lookupService.getAll("page_categories/" + this.type)
            .subscribe(
                data => {
                    this.categories = data.data;
                },
                error => {
                    this.handleError(error, this.pagesForm);
                });

        this.lookupService.getAll("zones")
            .subscribe(
                data => {
                    this.zones = data.data;
                },
                error => {
                    this.handleError(error, this.pagesForm);
                });

        if (this.id != 'new') {
            this.pageService.getRecord(this.id)
                .subscribe(
                    data => {
                        this.record = data.data;
                        this.draftPages = this.record.draft_pages;
                    },
                    error => {
                        this.record = {};
                        this.handleError(error, this.pagesForm);
                    });
        } else {
            this.record = {
                "related_entity_id": {"data": []},
                "sections": []
            };
        }
    }

    cancel() {
        this.close.emit();
    }

    reset(value) {
        if(value == 'page_start_date')
        this.record.page_start_date = '';
        else
        if(value == 'page_end_date')
        this.record.page_end_date = '';
      }

    save() {
        
        let related_entity_id =  this.record.related_entity_id;
        if (this.validateSections()) {
            if(this.type == 'assistance') this.record.type = 'assistance';

            if (this.id != 'new') {

                this.pageService.save(this.record)
                    .subscribe(
                        data => {
                            this.record = data.data;
                            this.draftsLookup(this.id);
                        },
                        error => {
                            this.handleError(error, this.pagesForm);
                        });

            } else {
                this.pageService.create(this.record)
                    .subscribe(
                        data => {
                            this.id = data.data.id;
                            this.record = data.data;
                            this.router.navigate(['/' + this.type + '/' + data.data.id]);
                        },
                        error => {
                            this.handleError(error, this.pagesForm);
                        });
            }
        }
    }
    
    validateSections() {
        let valid = true;
        if (this.record.sections) {
            for (let index = 0; index < this.record.sections.length; index++) {
                let section = new Section(this.id, this.record.sections[index]);
                let result = section.validate();
                this.record.sections[index] = section;
                // TODO: crawl thrown items
                if (!result) {
                    valid = false;
                }
            }
        }
        return valid;
    }

    nameChange() {
        if (this.id == 'new') {
            this.record.slug = this.string_to_slug(this.record.name);
        }
    }

    deleteSection(index) {
        if (confirm("Are you sure want to delete this section? Please note this will also delete all child items if any")) {
            this.record.sections.splice(index, 1);
        }
    }

    addSection() {
        let section = new Section(this.id);
        section.order = this.record.sections.length;
        this.record.sections.push(section);
    }

    orderedSections() {
        if (this.record && this.record.sections) {
            return this.record.sections.sort(function(a, b) {
                return (a.order == b.order) ? 0 : a.order > b.order ? 1 : -1;
            });
        } else {
            return [];
        }
    }

    moveSectionUp(i) {
        for (let index = 0; index < this.record.sections.length; index++) {
            if (index == i) {
                this.record.sections[index].order = index - 1;
            } else if (index == i - 1) {
                this.record.sections[index].order = index + 1;
            } else {
                this.record.sections[index].order = index;
            }
        }
    }
    moveSectionDown(i) {
        for (let index = 0; index < this.record.sections.length; index++) {
            if (index == i) {
                this.record.sections[index].order = index + 1;
            } else if (index == i + 1) {
                this.record.sections[index].order = index - 1;
            } else {
                this.record.sections[index].order = index;
            }
        }
    }

    PreviewPage(draftslug:any, id: any, fullpath:any): void{

        console.log(draftslug);
        if(this.type == 'poolspaguides'){
            const previewUrl = `/poolspaguidespreview/${id}/${draftslug}`;
            console.log(previewUrl);
            window.open(previewUrl, '_blank');
        }else{
            const previewUrl = `/pagepreview/${id}/${fullpath}`;
            window.open(previewUrl, '_blank');
        }
        // this.router.navigate([this.type + '/' + id + fullpath]);

    }

    editPage(id: number): void {
        console.log('current page', this.id, '- ' , id);
        this.draftsLookup(id);
        this.router.navigate(['/' + this.type + '/' + id]);
    }

    deletePage(id: any): void{
        const isConfirmed = window.confirm('Are you sure you want to delete this draft page?');

        if (isConfirmed) {
            this.pageService.draftdelete(id)
                .subscribe(
                    data => {
                        this.draftsLookup(this.id);
                    },
                    error => {
                        this.handleError(error, this.pagesForm);
                    }
                );
        }
    }

    draftsave() {
        let related_entity_id =  this.record.related_entity_id;
        if (this.validateSections()) {
            if(this.type == 'assistance') this.record.type = 'assistance';

            if (this.id != 'new') {

                this.pageService.draftsave(this.record)
                    .subscribe(
                        data => {
                            this.record = data.data;
                            this.router.navigate(['/' + this.type + '/' + data.data.id]);
                            this.draftsLookup(data.data.id);
                        },
                        error => {
                            this.handleError(error, this.pagesForm);
                        });

            } else {
                this.pageService.create(this.record)
                    .subscribe(
                        data => {
                            this.id = data.data.id;
                            this.record = data.data;
                            this.router.navigate(['/' + this.type + '/' + data.data.id]);
                            this.draftsLookup(this.id);
                        },
                        error => {
                            this.handleError(error, this.pagesForm);
                        });
            }
        }
    }

    draftsLookup(id: any){
        this.pageService.getRecord(id)
        .subscribe(
            data => {
                this.record = data.data;
                this.draftPages = this.record.draft_pages;
            },
            error => {
                this.record = {};
                this.handleError(error, this.pagesForm);
            });
    }


    openPublishDialog(draftrecordId: any): void {

        const dialogRef = this.dialog.open(PublishDialogComponent, {
            width: '500px',
            data: { draftrecordId: draftrecordId, record: this.record }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            const { selectedDate, selectedTime, publishNow, removeSchedule } = result;
            this.record = this.pagesForm.value;
            this.record.id = this.id;

            if (removeSchedule) {
              this.pageService.removeSchedule(this.record)
                .subscribe(response => {
                  this.draftsLookup(this.id);
                  console.log('Schedule removed successfully:', response);
                }, error => {
                  console.error('Error removing schedule:', error);
                });
            } else if (publishNow) {

              this.pageService.publishnow(this.record)
                .subscribe(response => {
                  this.draftsLookup(this.id);
                  console.log('Publish now successful:', response);
                }, error => {
                  this.handleError(error, this.pagesForm);
                });
            } else {
              this.pageService.publishschedule(this.record, selectedDate, selectedTime)
                .subscribe(response => {
                    this.draftsLookup(this.id);
                    console.log('Publish scheduled successfully:', response);
                }, error => {
                  console.error('Error scheduling publish:', error);
                });
            }
          } else {
            console.log('Dialog closed without result');
          }
        });
      }

}
